/*
    Store module mutations examples

*/
// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

// Start new mutation here
// eslint-disable-next-line no-unused-vars

export function setReportDatas (state, payload) {
  state.reportDatas = payload
}
